import { Star } from 'lucide-react';

export const StarRating = ({ value, onValueChange, hoverValue, onHoverChange, readonly = false, size = 'md' }) => {
  const sizeClass = size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-8 w-8' : 'h-6 w-6';
  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          disabled={readonly}
          onClick={() => !readonly && onValueChange?.(star)}
          onMouseEnter={() => !readonly && onHoverChange?.(star)}
          onMouseLeave={() => !readonly && onHoverChange?.(0)}
          className={`${readonly ? 'cursor-default' : 'cursor-pointer transition-transform hover:scale-110'}`}
        >
          <Star
            className={`${sizeClass} ${
              star <= (hoverValue || value)
                ? 'text-yellow-500 fill-yellow-500'
                : 'text-neutral-300'
            }`}
            strokeWidth={1.5}
          />
        </button>
      ))}
    </div>
  );
};
